import { render, staticRenderFns } from "./baogaoList.vue?vue&type=template&id=4c21ecb1&scoped=true"
import script from "./baogaoList.vue?vue&type=script&lang=js"
export * from "./baogaoList.vue?vue&type=script&lang=js"
import style0 from "./baogaoList.vue?vue&type=style&index=0&id=4c21ecb1&prod&rel=stylesheet%2Fless&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21ecb1",
  null
  
)

export default component.exports